import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import './loader.less';

class Loader extends React.Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'initial';
  }

  render() {
    return (
      <div className="full-page-loader">
        <CircularProgress color="primary" size={50} />
      </div>
    );
  }
}

export default Loader;
